﻿import { UploadImageModule } from './common';
import GroTranslator from './translator';
import { setDropdown } from './form-controls.js';

if ($.validator) {
    $.validator.addMethod(
        'subItemRequired',
        function (value, element, method) {
            return method;
        },
        ''
    );
    $.validator.addMethod(
        'regex',
        function (value, element, regexpr) {
            return this.optional(element) || regexpr.test(value);
        },
        'Please enter a valid value.'
    );
}

const MyAccountPage = {
    addUploadPopupEvent: () => {
        $(document).on('click', function () {
            $('.popup-sub').fadeOut();
        });

        //$(".popup-sub").click(function () { return false; });
        $('.lm__avatar .lm__avatar__upload-btn').click(function () {
            var popupSub = $(this).parent();
            if (popupSub.has('.popup-sub')) {
                popupSub.find('.popup-sub').fadeToggle();
            }
            return false;
        });
    },

    init: () => {
        MyAccountPage.addUploadPopupEvent();
        //Init for Profile picture
        var userParamsForUpload = MyAccountPage.getSettingsForUserUpload();
        var userUploadImageModule = UploadImageModule(userParamsForUpload);
        userUploadImageModule.initUploadFile();
        userUploadImageModule.initDeleteFile();

        //Init for User Card Profile picture
        var userCardParamsForUpload = MyAccountPage.getSettingsForUserCardUpload();
        var userCardUploadImageModule = UploadImageModule(userCardParamsForUpload);
        userCardUploadImageModule.initUploadFile();
        userCardUploadImageModule.initDeleteFile();

        //Init for Customer picture
        var companyUploadSettings = MyAccountPage.getSettingsForCompanyUpload();
        var companyUploadImageModule = UploadImageModule(companyUploadSettings);
        companyUploadImageModule.initUploadFile();
        companyUploadImageModule.initDeleteFile();
    },

    getSettingsForUserUpload: () => {
        return {
            fileSelector: '#user-avatar__file',
            previewImgSelector: '#user-avatar',
            uploadBtnSelector: '#user-uploadBtn',
            cancelUploadBtnSelector: '#user-cancelUpload',
            linkSelector: '#user-link',
            handleUrl: '/api/profile/user-upload-avatar',
            isNeedToUpdateHeader: true,
            deleteLinkSelector: '#user-deleteBtn',
            handleDeleteUrl: '/api/profile/user-delete-avatar',
            messages: {
                confirmationDialogSelector: '#dialog-user-confirmation',
            },
        };
    },

    getSettingsForUserCardUpload: () => {
        return {
            fileSelector: '#user-card-avatar__file',
            previewImgSelector: '#user-card-avatar',
            uploadBtnSelector: '#user-card-uploadBtn',
            cancelUploadBtnSelector: '#user-card-cancelUpload',
            linkSelector: '#user-card-link',
            handleUrl: '/api/usercard/user-card-upload-avatar',
            //isNeedToUpdateHeader: true,
            deleteLinkSelector: '#user-card-deleteBtn',
            handleDeleteUrl: '/api/usercard/user-card-delete-avatar',
            messages: {
                confirmationDialogSelector: '#dialog-user-card-confirmation',
            },
        };
    },

    getSettingsForCompanyUpload: () => {
        return {
            fileSelector: '#company-avatar__file',
            previewImgSelector: '#company-avatar',
            uploadBtnSelector: '#company-uploadBtn',
            cancelUploadBtnSelector: '#company-cancelUpload',
            linkSelector: '#company-link',
            handleUrl: '/api/profile/company-upload-avatar',
            deleteLinkSelector: '#company-deleteBtn',
            handleDeleteUrl: '/api/profile/company-delete-avatar',
            messages: {
                confirmationDialogSelector: '#dialog-company-confirmation',
            },
        };
    },
};

let unsaved = false;
let formSubmitting = false;

const HandinSignInInformationPage = {
    init: () => {
        var x = $('#SocialSecurityNumber').val();
        if (x != null && x !== '') {
            $('#SocialSecurityNumber').attr('disabled', true);
            $('#register-ssn-button').addClass('disabled');
            //$('.lm__block .lm__checkbox').show();
        }

        $('#SocialSecurityNumber').change(function () {
            unsaved = true;
        });

        window.onload = function () {
            window.addEventListener('beforeunload', function (e) {
                if (formSubmitting || !unsaved) {
                    return undefined;
                }

                var confirmationMessage =
                    'It looks like you have been editing something. ' +
                    'If you leave before saving, your changes will be lost.';

                (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
            });
        }

        const updateSSNForm = document.querySelector('#updateSocialNumberForm');
        if (updateSSNForm) {
            updateSSNForm.addEventListener('submit', HandinSignInInformationPage.updateSSN);
        }
            
    },

    updateSSN : (evt) => {
        const validate = HandinSignInInformationPage.validateForm();

        if (validate === false) {
            evt.preventDefault();
        }
    },

    validateFormError: () => {
        $('#SocialSecurityNumber').addClass('error');
        $('#error-message').show().html('Ogiltigt personnummer');
        $('.lm__block .lm__checkbox').hide();
    },

    validateForm: () => {
        var ssn = $('#SocialSecurityNumber').removeClass('error').val();
        $('#error-message').hide();
        if (ssn === null || ssn === '') {
            $('#SocialSecurityNumber').addClass('error');
            $('#error-message').show().html('Personnummer måste fyllas i');
            $('.lm__block .lm__checkbox').hide();
            return false;
        }
        //removes - from SSN;
        ssn = ssn.replace(/-/g, '');

        // Check that ssn contains only digits and digitcount is 10 or 12
        var rex = /^([0-9]{10}|[0-9]{12})$/;
        if (!rex.test(ssn)) {
            $('#SocialSecurityNumber').addClass('error');
            $('#error-message').show().html('Du måste ange 12 siffror (ÅÅÅÅMMDDNNNN)');
            $('.lm__block .lm__checkbox').hide();

            return false;
        }

        // convert 10-length SSN to 12-length 881201xxxx becomes 19881201xxxx
        // code assumes person is not born less than 18 years ago
        if (ssn.length === 10) {
            var currentYear = new Date().getFullYear();
            var currentYearTwoFirst = currentYear.toString().slice(0, 2);

            if (currentYear - 18 < parseInt(currentYearTwoFirst + ssn[0] + ssn[1])) {
                ssn = (currentYear - 100).toString().slice(0, 2) + ssn;
            } else {
                ssn = currentYearTwoFirst + ssn;
            }
        }

        // Check that birthdate has existed and is in the past
        var birthYear = parseInt(ssn.slice(0, 4)),
            birthMonth = parseInt(ssn.slice(4, 6)),
            birthDay = parseInt(ssn.slice(6, 8));

        // handle "samordningsnummer" where 60 is added to birthday
        if (birthDay > 60) {
            birthDay = birthDay - 60;
        }

        var birthDate = new Date(birthYear, birthMonth - 1, birthDay); // js months are 0-indexed
        var isRealDate =
            birthYear === birthDate.getFullYear() &&
            birthMonth - 1 === birthDate.getMonth() &&
            birthDay === birthDate.getDate();
        if (birthDate > Date.now() || !isRealDate) {
            HandinSignInInformationPage.validateFormError();
            return false;
        }

        //Checks last number in SSN
        var ssnArray = ssn.split('');
        var lastSsnNumber = 0;
        for (var i = 2; i < ssnArray.length; i++) {
            ssnArray[i] = ssnArray[i] * 2;
            i++;
        }
        for (var i = 2; i < ssnArray.length - 1; i++) {
            if (ssnArray[i] > 9) {
                var split = ssnArray[i].toString().split('');
                ssnArray[i] = parseInt(split[0]) + parseInt(split[1]);
            }
            lastSsnNumber = lastSsnNumber + parseInt(ssnArray[i]);
        }
        lastSsnNumber = 10 - (lastSsnNumber % 10);
        if (lastSsnNumber === 10) lastSsnNumber = 0;

        if (lastSsnNumber.toString() !== ssn[11]) {
            HandinSignInInformationPage.validateFormError();
            return false;
        }
        //End calculating security number in SSN
        formSubmitting = true;
    },
};

const CompanyInformation = {
    init: () => {
        $(document).ready(function () {
            if ($().validate) {
                $('#editCompanyInformationFrom').validate({
                    errorElementClass: 'error',
                    errorClass: 'error-item',
                    errorElement: 'span',
                    rules: {
                        CompanyName: 'required',
                        Address: 'required',
                        ZipCode: {
                            required: true,
                            zipCode: true,
                        },
                        City: 'required',
                        PhoneMobile: {
                            required: true,
                            mobileSE: true,
                        },
                        PhoneWork: {
                            phoneSE: true,
                        },
                        Email: {
                            required: true,
                            regex: /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i,
                        },
                    },
                    messages: {
                        // @translate
                        CompanyName: GroTranslator.get('/common/validation/companyname/required'),
                        Address: GroTranslator.get('/common/validation/address/required'),
                        ZipCode: {
                            required: GroTranslator.get('/common/validation/zipcode/required'),
                            zipCode: window['validationMessage'].zipCode.valid,
                        },
                        City: {
                            required: GroTranslator.get('/common/validation/city/required'),
                        },
                        PhoneMobile: {
                            required: window['validationMessage'].mobileSE.required,
                            mobileSE: window['validationMessage'].mobileSE.valid,
                        },
                        PhoneWork: {
                            phoneSE: window['validationMessage'].phoneSE.valid,
                        },
                        Email: {
                            required: GroTranslator.get('/common/validation/email/required'),
                            email: GroTranslator.get('/common/validation/email/valid'),
                        },
                    },
                    highlight: function (element, errorClass, validClass) {
                        $('div.errors-list').hide();
                        $('ul.errors-list').show();
                        $('li#p_' + $(element).attr('id')).show();
                        $(element)
                            .addClass(this.settings.errorElementClass)
                            .removeClass(errorClass);
                    },
                    unhighlight: function (element, errorClass, validClass) {
                        $(element)
                            .removeClass(this.settings.errorElementClass)
                            .removeClass(errorClass);
                        $('li#p_' + $(element).attr('id')).hide();
                        if ($('ul.errors-list').find('li[id^="p"]').is(':visible') === false) {
                            $('ul.errors-list').hide();
                        }
                    },
                });
            }
        });
    },
};

const BusinessProfile = {
    init: () => {
        $(document).ready(function () {
            if ($().validate) {
                $('#editBusinessProfileForm').validate({
                    errorElementClass: 'error',
                    errorClass: 'error-item',
                    errorElement: 'span',
                    rules: {
                        'BusinessProfile.Name': 'required',
                    },
                    messages: {
                        'BusinessProfile.Name': GroTranslator.get(
                            '/common/validation/businessprofile/required'
                        ),
                    },
                    highlight: function (element, errorClass, validClass) {
                        $('div.errors-list').hide();
                        $('ul.errors-list').show();
                        $('li#p_' + $(element).attr('id')).show();
                        $(element)
                            .addClass(this.settings.errorElementClass)
                            .removeClass(errorClass);
                    },
                    unhighlight: function (element, errorClass, validClass) {
                        $(element)
                            .removeClass(this.settings.errorElementClass)
                            .removeClass(errorClass);
                        $('li#p_' + $(element).attr('id')).hide();
                        if ($('ul.errors-list').find('li[id^="p"]').is(':visible') === false) {
                            $('ul.errors-list').hide();
                        }
                    },
                });
            }
        });
    },
};

const DeliveryAddress = {
    addDeleteAddressHandler: () => {
        var $delElement = $('#del-delivery-address');
        if ($delElement.length > 0) {
            $delElement.click(function (e) {
                e.preventDefault();
                var addressNumber = $('#addressNumber').val().toString();
                var handlePageId = $('#handler-delivery-page-id').val().toString();
                var apiUrl =
                    '/api/handle-delivery-address/delete/' + addressNumber + '/' + handlePageId;
                $.ajax({
                    dataType: 'html',
                    url: apiUrl,
                    cache: false,
                    success: function (data) {
                        if (!!data && data.toString().trim() !== '') {
                            window.location = data;
                        }
                    },
                });
            });
        }
    },

    generateSiloRow: (rowIdx) => {
        var siloBox =
            "<div class='author-inform-form__column author-inform-form__column-full silos-box gray-background'> </div>";
        var delBtn = "<a href='#' class='silos-box__delete-btn'></a>";
        var silorDesc =
            ' <span>' +
            GroTranslator.get('/deliveryaddress/silonumber') +
            "*</span> <input type='text' name='Silos[" +
            rowIdx +
            "].Number' class='silos silo-number' />";

        var silosFirstValue = $('#SilosFirstValue').val();
        var silosSecondValue = $('#SilosSecondValue').val();
        var silosThirdValue = $('#SilosThirdValue').val();
        var siloAccessibility = '';
        if (silosFirstValue || silosSecondValue || silosThirdValue) {
            silorDesc +=
                '<span>' + GroTranslator.get('/deliveryaddress/accessibility') + '* </span>';
            siloAccessibility =
                " <ul class='lm__form-dropdown type-3'>" +
                "<li class='showcase' data-value='10M'>" +
                "<a href='#' id='selected-silor" +
                rowIdx +
                "'>" +
                (silosFirstValue
                    ? silosFirstValue
                    : '10 ' + GroTranslator.get('/common/units/meters')) +
                '</a>' +
                "<ul class='dropdown'>" +
                "<li data-value='10M' class='selected'><a href='#'>" +
                (silosFirstValue
                    ? silosFirstValue
                    : '10 ' + GroTranslator.get('/common/units/meters')) +
                '</a></li>' +
                "<li data-value='18M'><a href='#'>" +
                (silosSecondValue
                    ? silosSecondValue
                    : '18 ' + GroTranslator.get('/common/units/meters')) +
                '</a></li>' +
                "<li data-value='24M'><a href='#'>" +
                (silosThirdValue
                    ? silosThirdValue
                    : '24 ' + GroTranslator.get('/common/units/meters')) +
                '</a></li>' +
                '</ul>' +
                "<input type='hidden' class='form-element silo-accessibility' name='Silos[" +
                rowIdx +
                "].Accessibility' value='10M' />" +
                '</li>' +
                '</ul>';
        }
        return $(siloBox).append(delBtn, silorDesc, siloAccessibility);
    },

    setSelectedDropdown: () => {
        var selectedValue = $('#editDeliveryAddress .lm__form-dropdown .showcase').attr(
            'data-value'
        );
        if (!selectedValue) {
            return;
        }

        var liItems = $('.lm__form-dropdown .dropdown li');
        // reset selected state
        liItems.removeClass('selected');
        liItems.each(function () {
            var data = $(this).attr('data-value');

            if (data == selectedValue) {
                $(this).addClass('selected');
            }
        });
    },

    addSilo: () => {
        $('#btn-add-silo').click(function (e) {
            var rowCount = $('div.silos-box').length;
            var silorContainer = $('.silo-container');
            var newRow = DeliveryAddress.generateSiloRow(rowCount);
            silorContainer.append(newRow);
            setDropdown($('.lm__form-dropdown'), 'type-3');

            DeliveryAddress.addRemoveSiloHandler();

            e.preventDefault();
        });
    },

    addRemoveSiloHandler: () => {
        $('.silos-box__delete-btn').click(function (e) {
            e.preventDefault();
            $(this).closest('div.silos-box').remove();
            $('input.silo-number').each(function (idx, item) {
                $(this).attr('name', 'Silos[' + idx + '].Number');
            });
            $('input.silo-accessibility').each(function (idx, item) {
                $(this).attr('name', 'Silos[' + idx + '].Accessibility');
            });
        });
    },

    showOrHideDialog: (name) => {
        var indicatorId = '#has-' + name + '-indicator';
        var $itemIndicator = $(indicatorId);
        if ($itemIndicator && $itemIndicator.length > 0) {
            var updateSuccess = $itemIndicator.val().toString().toLowerCase() === 'true';
            if (updateSuccess) {
                //show success dialog
                var modalId = '#modal-' + name + '.lm__information-modal__wrapper';
                var modal = $(modalId);
                modal.removeClass('hidden');
            }
        }
    },

    addNotificationReceiverHandler: () => {
        var $receiverCheckBox = $('input.notification-receiver-handler');
        if (!!$receiverCheckBox && $receiverCheckBox.length > 0) {
            $receiverCheckBox.click(function () {
                $(this).val($(this).is(':checked'));
            });
        }
    },

    addProfileFormValidationHandler: () => {
        if ($('.js-page-identifier-profile-page').length) {
            $('#edit-profile-form').validate({
                errorElement: 'div',
                errorClass: 'error',
                rules: {
                    FirstName: {
                        required: true,
                    },
                    LastName: {
                        required: true,
                    },
                    Mobilephone: {
                        required: true,
                        mobileSE: true,
                    },
                    Telephone: {
                        phoneSE: true,
                    },
                    Email: {
                        required: true,
                        regex: /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i,
                    },
                    Zip: {
                        zipCode: true,
                        regex: /^(\d\d\d \d\d|\d\d\d\d\d)$/i,
                    },
                },

                messages: {
                    FirstName: window['validationMessage'].firstName.required,
                    LastName: window['validationMessage'].lastName.required,
                    Mobilephone: {
                        required: window['validationMessage'].mobileSE.required,
                        mobileSE: window['validationMessage'].mobileSE.valid,
                    },
                    Telephone: {
                        phoneSE: window['validationMessage'].phoneSE.valid,
                    },
                    Email: {
                        required: window['validationMessage'].email.required,
                        email: window['validationMessage'].email.valid,
                    },
                    Zip: {
                        zipCode: window['validationMessage'].zipCode.valid,
                        regex: window['validationMessage'].zipCode.valid,
                    },
                },
                highlight: function (element, errorClass) {
                    $(element).addClass(errorClass);
                },
            });
        }
    },

    addUserAgreementHandler: () => {
        if ($('.js-page-identifier-user-agreement').length) {
            var url = $('.js-page-identifier-user-agreement').data('url');
            document.getElementById('logoutRedirect').value = location.origin + url;
        }
    },

    init: () => {
        DeliveryAddress.showOrHideDialog('added');
        DeliveryAddress.showOrHideDialog('updated');
        DeliveryAddress.showOrHideDialog('deleted');
        DeliveryAddress.addProfileFormValidationHandler();

        if (!$('#editDeliveryAddress') || $('#editDeliveryAddress').length == 0) {
            return;
        }
        DeliveryAddress.setSelectedDropdown();
        DeliveryAddress.addSilo();
        DeliveryAddress.addRemoveSiloHandler();
        DeliveryAddress.addDeleteAddressHandler();
        DeliveryAddress.addNotificationReceiverHandler();
        DeliveryAddress.addUserAgreementHandler();
    },
};

window.HandinSignInInformationPage = HandinSignInInformationPage;

$(function () {
    MyAccountPage.init();
    HandinSignInInformationPage.init();
    CompanyInformation.init();
    BusinessProfile.init();
    DeliveryAddress.init();
});
